import { Icons } from '@assets/svg'
import { colors, theme } from '@config/theme'
import { DatesList } from '@stories/Components/DatesList/DatesList.tsx'
import { DatesOneDay } from '@stories/Components/DatesOneDay/DatesOneDay.tsx'
import { DatesOneWeek } from '@stories/Components/DatesOneWeek/DatesOneWeek.tsx'
import { parseISO } from 'date-fns'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

type DatesElementProps = { dates: string[] | null }
export const DatesElement: React.FC<DatesElementProps> = ({ dates }) => {
  const getISOWeekStart = (date: Date): string => {
    const day = date.getDay()
    const diff = (day === 0 ? -6 : 1) - day // Move back to Monday
    const monday = new Date(date)
    monday.setDate(date.getDate() + diff)
    monday.setHours(0, 0, 0, 0)
    return monday.toISOString().split('T')[0]
  }

  let dateModuleType: 'default' | 'one-day' | '1week' = 'default'
  if (!dates || dates.length === 0) {
    dateModuleType = 'default'
  } else if (dates.length === 1) {
    dateModuleType = 'one-day'
  } else {
    const parsedDates = dates.map((date) => parseISO(date))
    const weekStart = getISOWeekStart(parsedDates[0])
    const allSameWeek = parsedDates.every((date) => getISOWeekStart(date) === weekStart)
    if (!allSameWeek) {
      dateModuleType = 'default'
    } else {
      const weekdays = parsedDates.map((d) => d.getDay()).sort((a, b) => a - b)
      const expectedWeekdays = [1, 2, 3, 4, 5]

      if (dates.length === 5 && expectedWeekdays.every((day, index) => day === weekdays[index])) {
        dateModuleType = '1week'
      }

      if (dates.length === 4 && expectedWeekdays.filter((day) => !weekdays.includes(day)).length === 1) {
        dateModuleType = '1week'
      }
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Container data-testid={'date-module'}>
        <Title>
          <Icons.CalendarIcon /> Dates
        </Title>
        {dateModuleType === 'one-day' && <DatesOneDay date={dates ? dates[0] : null} />}
        {dateModuleType === '1week' && <DatesOneWeek dates={dates} />}
        {dateModuleType === 'default' && <DatesList dates={dates} />}
      </Container>
    </ThemeProvider>
  )
}

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  //max-width: 400px;
  min-width: 100px;
  align-items: center;

  @media${({ theme }) => theme.device['md']} {
    min-width: 300px;
  }
`

const Title = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  line-height: 1.25rem;
  margin-bottom: 1rem;
  align-self: flex-start;
  color: ${colors.brandGray900};
  font-weight: 600;
  svg {
    margin-right: 0.5rem;
  }
`
